var systemFontsDefaultLetterSpacing = function systemFontsDefaultLetterSpacing() {
  var fontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  var letterSpacing = 0;

  if (typeof fontSize === 'string') {
    console.error('Text expects fontSize as number to calculate correct letterSpacing. If you can\'t pass fontSize as number, make sure to pass also consistent with designs letterSpacing.');
    return letterSpacing;
  }

  if (typeof fontSize === 'undefined') {
    return letterSpacing;
  }

  if (fontSize > 32) {
    letterSpacing = 0.1;
  } else if (fontSize <= 32 && fontSize > 19) {
    letterSpacing = 0.3;
  } else if (fontSize <= 19) {
    letterSpacing = 0;
  }

  return letterSpacing;
};

export default systemFontsDefaultLetterSpacing;
//# sourceMappingURL=index.js.map